import { DoorClosedCancelIcon } from './DoorClosedCancelIcon';

/**
 * author: Michael Richins
 * id 4F2F0F07-CF86-40E1-A204-E5BAB501B5F5
 * name door-closed-cancel
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-closed-cancel.svg
 * tags
 * - Home Automation 
 */
export const DoorUnavailableIcon = DoorClosedCancelIcon;
export default DoorUnavailableIcon